import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, ArrowUp, ShieldCheck, Award } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Our Services', href: '#services' },
    { name: 'Products', href: '#products' },
    { name: 'Contact', href: '#contact' },
  ];

  const servicesLinks = [
    { name: 'Fire Hydrant Systems', href: '#' },
    { name: 'Fire Alarm & Detection', href: '#' },
    { name: 'Sprinkler Systems', href: '#' },
    { name: 'NOC Consultation', href: '#' },
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ];

  return (
    <footer className="bg-[#0f0f1a] relative overflow-hidden border-t border-white/5 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold font-barlow text-white uppercase tracking-tight mb-4 flex items-center gap-2">
              <span className="w-8 h-8 bg-primary rounded flex items-center justify-center text-white">
                <ShieldCheck className="w-5 h-5" />
              </span>
              Kashyap Engg.
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Engineering safety you can trust. Comprehensive fire solutions protecting lives and assets across India.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social, idx) => {
                const Icon = social.icon;
                return (
                  <a key={idx} href={social.href} aria-label={social.label} className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:bg-primary hover:text-white hover:border-primary transition-all duration-300">
                    <Icon className="w-4 h-4" />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white font-barlow uppercase tracking-wider mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href} className="text-gray-400 hover:text-primary transition-colors flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary/0 group-hover:bg-primary transition-colors" />
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white font-barlow uppercase tracking-wider mb-6">Core Services</h4>
            <ul className="space-y-3">
              {servicesLinks.map((link, idx) => (
                <li key={idx}>
                  <a href={link.href} className="text-gray-400 hover:text-primary transition-colors flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-full bg-secondary/0 group-hover:bg-secondary transition-colors" />
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Certifications & Trust */}
          <div>
            <h4 className="text-lg font-bold text-white font-barlow uppercase tracking-wider mb-6">Certifications</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-3 rounded-lg bg-white/5 border border-white/10">
                <Award className="w-8 h-8 text-accent" />
                <div>
                  <div className="text-white font-bold text-sm">ISO 9001:2015</div>
                  <div className="text-gray-400 text-xs">Quality Management</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-lg bg-white/5 border border-white/10">
                <ShieldCheck className="w-8 h-8 text-primary" />
                <div>
                  <div className="text-white font-bold text-sm">CE Certified</div>
                  <div className="text-gray-400 text-xs">European Standards</div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} Kashyap Engineering. All rights reserved.
          </p>
          <button 
            onClick={scrollToTop} 
            className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:bg-white hover:text-dark transition-all duration-300"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-5 h-5" />
          </button>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
